import { render, staticRenderFns } from "./BandwidthChart.vue?vue&type=template&id=4e6c1888"
import script from "./BandwidthChart.vue?vue&type=script&lang=ts"
export * from "./BandwidthChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports